import axios from "axios";

export default {
    state: {
        bankAccountCurrencies: [],
        filter: {}
    },
    getters: {
        BANK_ACCOUNT_CURRENCIES: state => {
            return state.bankAccountCurrencies;
        },
        BANK_ACCOUNT_CURRENCIES_FILTER: state => {
            return state.filter;
        }
    },
    mutations: {
        SET_BANK_ACCOUNT_CURRENCIES: (state, payload) => {
            state.bankAccountCurrencies = payload;
        },
    },
    actions: {
        GET_BANK_ACCOUNT_CURRENCIES: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios
                  .get(`bankAccountCurrencies`)
                  .then(({ data, status }) => {
                    if (status === 200) {
                        commit("SET_BANK_ACCOUNT_CURRENCIES", data);
                        resolve(true);
                    }
                  })
                  .catch(error => {
                    reject(error);
                });
            });
        },
    }
}